import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    id: "one-on-one",
    t: "1-to-1 PLST",
    d: "Dedicated one-to-one strength training with a physiotherapist. Ideal when you need closer guidance because of pain, injury, health considerations, return to sport, or a specific performance goal.",
    img: "/media/one-to-one-plst.webp",
  },
  {
    id: "semi-supervised",
    t: "Semi-Supervised PLST",
    d: "Your program. Your pace. Expert guidance when you need it. Train independently within a supervised environment, with your physiotherapist guiding your exercises, loads and progressions.",
    img: "/media/semi-supervised-plst.webp",
  },
  {
    id: "physio",
    t: "Physiotherapy",
    d: "For times when pain or injury needs more attention. Assessment, treatment and rehabilitation to help you recover, rebuild and move confidently back towards exercise and strength training.",
    img: "/media/physiotherapy.webp",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-40 bg-[#F5F4EF]" data-testid="services-section">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.8 }} className="md:col-span-8"
          >
            <div className="text-xs uppercase tracking-[0.28em] text-[#8A8A8A]">
              <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
              Services
            </div>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Three ways to work <br />
              <span className="italic font-medium text-[#A67C00]">with us.</span>
            </h2>
          </motion.div>
          <p className="md:col-span-4 text-[#1E1E1E]/70 leading-relaxed">
            Whether you're starting strength training, working around an injury, or training towards a specific goal, we help you find the level of guidance that's right for you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group relative border border-[#1E1E1E]/10 hover:border-[#A67C00] transition-all bg-white overflow-hidden img-zoom flex flex-col"
              data-testid={`service-${s.id}`}
            >
              <div className="relative w-full h-[240px] lg:h-[280px] overflow-hidden">
                <img src={s.img} alt={s.t} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1E1E1E]/40 to-transparent" />
              </div>
              <div className="p-6 lg:p-8 flex flex-col flex-1">
                <div className="flex items-baseline gap-3">
                  <span className="italic font-medium text-xl text-[#A67C00]">0{i + 1}</span>
                  <h3 className="font-display text-2xl md:text-3xl tracking-tight text-[#1E1E1E]">{s.t}</h3>
                </div>
                <p className="mt-3 text-[#1E1E1E]/70 leading-relaxed flex-1">{s.d}</p>
                <Link
                  to="/book"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#1E1E1E] group-hover:text-[#A67C00] transition-colors"
                >
                  Enquire <span className="transition-transform group-hover:translate-x-1">→</span>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
